import React, { createContext, useContext, useEffect, useState } from "react";

const ModalLoginContext = createContext(null);

export const ModalLoginProvider = ({ children }) => {
  const [isOpen, setIsOpen] = useState(false);
  const [isCsModalActive, setIsCsModalActive] = useState(false);

  useEffect(() => {
    if (isOpen) setIsCsModalActive(false);
  }, [isOpen, setIsCsModalActive]);

  useEffect(() => {
    if (isCsModalActive) setIsOpen(false);
  }, [isCsModalActive, setIsOpen]);

  return (
    <ModalLoginContext.Provider
      value={{ isOpen, setIsOpen, isCsModalActive, setIsCsModalActive }}
    >
      {children}
    </ModalLoginContext.Provider>
  );
};

export const useModalLogin = () => useContext(ModalLoginContext);
